import { Injectable } from '@angular/core';
import { IDiscount } from '../model/discount';
import { StorageBackedStore } from './storage-backed-store';

@Injectable({ providedIn : 'root'})
export class DiscountsStore extends StorageBackedStore<IDiscount[]> {
    constructor() {
        super('discounts', []);
    }
}